// currently this is only being used in availability component
// this will turn "5.5" to "5:30" or 5 to "5:00" which is pretty much the opposite of toSliderValue
export function fromSliderToString(num: number): string {
  return Number.isInteger(num) ? `${num}:00` : `${Math.floor(num)}:30`;
}
